<template>
    <ion-footer color="transparent" class="px-4 py-2">
        <ion-button :disabled="disabled" expand="block" @click="$emit('update')">
            <ion-icon size="small" slot="start" :icon="save"></ion-icon>
            <ion-label>Opslaan</ion-label>
        </ion-button>
    </ion-footer>
</template>
<script>
import { save } from 'ionicons/icons';
export default {
    props: ['disabled'],
    data() {
        return {
            save,
        }
    }
}
</script>
<style lang="">
    
</style>
